import { useState, useRef, useEffect } from "react";
import { FiChevronDown } from "react-icons/fi";
import "./style/Dropdown.css";

export default function Dropdown({
  label,
  items = [],
  selected,
  onSelect,
  itemLabel = (x) => x,
  loading = false,
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const [direction, setDirection] = useState("down");
  const wrapperRef = useRef(null);
  const menuRef = useRef(null);

  // ▼ Auto position: up/down
  useEffect(() => {
    if (!open || loading) return;

    const rect = wrapperRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const spaceBelow = viewportHeight - rect.bottom;
    const estimatedMenuHeight = Math.min(250, items.length * 42);

    setDirection(spaceBelow < estimatedMenuHeight ? "up" : "down");
  }, [open, loading, items]);

  // ▼ Click outside
  useEffect(() => {
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="dd-wrapper" ref={wrapperRef}>
      <button
        className="dd-btn"
        onClick={() => !loading && setOpen(!open)}
        disabled={loading}
      >
        <span className="dd-label">
          {loading ? "Loading..." : selected ? itemLabel(selected) : label}
        </span>
        {disabled ? null : (
          <FiChevronDown className={`dd-icon ${open ? "rotate" : ""}`} />
        )}
      </button>

      {!disabled && open && !loading && (
        <div
          ref={menuRef}
          className={`dd-menu ${direction === "up" ? "open-up" : "open-down"}`}
        >
          {items.map((item, idx) => (
            <div
              key={idx}
              className={`dd-item ${
                selected && itemLabel(item) === itemLabel(selected)
                  ? "active"
                  : ""
              }`}
              onClick={() => {
                onSelect(item);
                setOpen(false);
              }}
            >
              {itemLabel(item)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
